/* eslint-disable */
export default {
  fr: {
    common: {},
    menu: {
      dashboard: 'Tableau de Bord',
      send_referral: 'Recommander',
      view_referrals: 'Mes Recommandations',
      view_members: 'Mes membres'
    },
    dashboard: {
      header_title: 'Tableau de Bord',
      block: {
        referrals_stats: {
          title: 'Statistiques des Recommandations',
          indicators: {
            this_month: 'Mes recommandations du mois',
            actives: 'Recommandations actives',
            unclaimed_over_7_days: 'Recommandations non-utilisées depuis 7 jours',
            mean_org: 'Moyenne des recommandations dans mon organisation ce mois-ci'
          }
        },
        unclaimed_referrals: {
          title: 'Recommandations non-utilisées',
          none: 'Aucune recommandation non-utilisée.',
          columns: {
            sent: 'Date d\'Envoi',
            since: 'Temps écoulé',
            name: 'Nom',
            id: 'Identifiant'
          },
          buttons: {
            view_less: 'Voir moins',
            view_more: 'Voir plus',
            view_all: 'Voir toutes mes recommandations',
            resend: 'Renvoyer',
            view: 'Afficher'
          },
          confirmations: {
            resend: {
              title: 'Réenvoyer la recommandation ?',
              text: 'Êtes vous certain de vouloir renvoyer une notification au demandeur {firstname} {lastname} ?'
            }
          },
          notifications: {
            sent: {
              title: 'Notification envoyée',
              text: 'Le demandeur {firstname} {lastname} a été correctement notifié.'
            },
            not_sent: {
              title: 'Notification not sent',
              text: 'Une erreur inattendue s\'est produite. Le demandeur {firstname} {lastname} n\'a pas été notifié.'
            }
          }
        },
        members: {}
      },
      leaderboard: {
        title: 'Leaderboard',
        none: 'No data available',
        columns: {
          first_name: 'First Name',
          last_name: 'Last Name',
          total_referrals: 'Total Referrals',
          accepted_referrals: 'Accepted Referrals',
          acceptance_rate: 'Acceptance Rate',
          expired_referrals: 'Expired Referrals'
        },
        buttons: {
          view_less: 'View Less',
          view_more: 'View More',
          view_all: 'View All Leaders'
        },
      },
      buttons: {
        send_referral: 'Enovyer une Recommandation'
      }
    },
    send_referral: {
      header_title: 'Envoyer une recommandation au nom de {name}',
      claimant: {
        title: 'A qui souhaitez-vous recommander Starling?',
        fields: {
          firstname: 'Prénom',
          lastname: 'Nom de famille',
          email: 'Email',
          businessUnit: 'Unité organisationnelle',
          profession: 'Profession',
          noChoice: 'Aucune / Inconnue',
          team: 'Équipe'
        }
      },
      claim: {
        title: 'Comment les identifiez-vous ?',
        fields: {
          claimNumber: 'Identifiant Utilisateur',
          claimNumberHint: '(ex : numéro d\'employé ou de demandeur)',
          policyNumber: 'Numéro de police'
        }
      },
      action: {
        title: 'Veuillez leur choisir un programme:',
        fields: {
          program: 'Programme',
          lastDayAtWork: 'Dernier jour travaillé'
        }
      },
      message: {
        title: 'Voulez-vous leur laisser un message personnalisé?'
      },
      buttons: {
        send: 'Envoyer la recommandation',
        preview: 'Aperçu',
        cancel: 'Annuler'
      }
    },
    view_referrals: {
      header_title: 'Mes Recommandations',
      first_sent: 'Date d\'envoi',
      name: 'Nom',
      program: 'Programme',
      referral_status: 'Statut',
      view_member: 'Détail du membre',
      team: 'Équipe',
      buttons: {
        resend: 'Renvoyer',
        view: 'Afficher',
        view_member: 'Voir le membre',
        cancel: 'Annuler'
      }
    },
    view_referral: {
      header_title: 'Détail de la Recommandation',
      block: {
        timeline: {
          title: 'Chronologie',
          types: {
            CREATED: 'Créée',
            CREATED_FROM: 'Dupliquée',
            NOTIFICATION_SENT: 'Notification envoyée',
            BOUNCED: 'Notification non-délivrée',
            OPENED: 'Ouverte',
            LINK_CLICKED: 'Lien cliqué',
            CANCELLED: 'Abandonnée',
            ACCEPTED: 'Acceptée'
          }
        },
        information: {
          title: 'Information',
          claimant: {
            title: 'A qui souhaitez-vous recommander Starling?',
            fields: {
              firstname: 'Prénom',
              lastname: 'Nom de famille',
              email: 'Email',
              businessUnit: 'Unité organisationnelle',
              profession: 'Profession'
            }
          },
          claim: {
            title: 'Comment les identifiez-vous ?',
            fields: {
              claimNumber: 'Identifiant Utilisateur',
              policyNumber: 'Numéro de police',
              team: 'Équipe'
            }
          },
          action: {
            title: 'Veuillez leur choisir un programme:',
            fields: {
              program: 'Programme',
              lastDayAtWork: 'Dernier jour travaillé'
            }
          },
          message: {
            title: 'Voulez-vous leur laisser un message personnalisé?'
          }
        }
      },
      buttons: {
        delete: 'Supprimer',
        resend: 'Renvoyer',
        view_email: 'Aperçu de l\'email',
        edit: 'Modifier'
      }
    },
    edit_referral:{
      header_title:'Modifier la Recommandation'
    },
    filters: {
      REFERRAL_PROGRAMS: {
        title: 'Programmes',
        values: {
          none:'None',
          MENTAL_FITNESS: 'Santé Mentale',
          RTH_MENTAL: 'Retrouver la santé - Mentale',
          RTH_PHYSICAL: 'Retrouver la santé - Physique',
          RTH_VETERANS: 'Retrouver la santé - Vétérans'
        }
      },
      REFERRAL_DATES: {
        title: 'Dates',
        values: {
          NO_FILTER: 'Aucun filtre',
          CURRENT_WEEK: 'Cette semaine',
          CURRENT_MONTH: 'Ce mois-ci',
          LAST_7_DAYS: '7 derniers jours',
          LAST_30_DAYS: '30 derniers jours'
        }
      },
      REFERRAL_STATUS: {
        title: 'Statut',
        values: {
          SENT: 'Envoyée',
          OPENED: 'Ouverte',
          LINK_CLICKED: 'Lien Cliqué',
          ACCEPTED: 'Acceptée',
          CANCELLED: 'Abandonnée',
          ERRORED: 'En erreur'
        }
      },
      HQ_TEAMS: {
        title: 'Équipe'
      }
    },
    assessments:{
      title: 'Current Assessment Scores',
      'CD-RISC2': {
        name: 'CD-RISC2',
        label: 'Résilience',
        color: '#30CEFA',
        order: 0,
      },
      ENERGY: {
        name: 'ENERGY',
        label: 'Énergie',
        color: '#08E9cf',
        order: 1,
      },
      GAD7: {
        name: 'GAD7',
        label: 'Anxiété',
        color: '#FF777D',
        order: 2,
      },
      PHQ9: {
        name: 'PHQ9',
        label: 'Dépression',
        color: '#4c75aa',
        order: 3,
      },
      STRESS: {
        name: 'STRESS',
        label: 'Stress',
        color: '#ffb844',
        order: 4,
      },
      drilldown: {
        unavailable: 'Aucune interpretation de cette évaluation n\'est disponible pour le moment.',
      },
      scoreScale: [
        {
          value: 1,
          name: 'HH',
          labels: {
            long: 'En santé : moyenne élevée',
            short: 'Santé +',
          },
        },
        {
          value: 2,
          name: 'HA',
          labels: {
            long: 'En santé : moyenne',
            short: 'Santé',
          },
        },
        {
          value: 3,
          name: 'HL',
          labels: {
            long: 'En santé : moyenne faible',
            short: 'Santé -',
          },
        },
        {
          value: 4,
          name: 'BL',
          labels: {
            long: 'Frontière',
            short: 'Front.',
          },
        },
        {
          value: 5,
          name: 'ML',
          labels: {
            long: 'Léger',
            short: 'Léger',
          },
        },
        {
          value: 6,
          name: 'MO',
          labels: {
            long: 'Modérée',
            short: 'Modérée',
          },
        },
        {
          value: 7,
          name: 'SE',
          labels: {
            long: 'Grave',
            short: 'Grave',
          },
        },
      ],
      simplifiedScoreScale: [
        {
          value: 3,
          name: 'HI',
          label: 'Élevé(e)',
        },
        {
          value: 2,
          name: 'MD',
          label: 'Moyen(ne)',
        },
        {
          value: 1,
          name: 'LO',
          label: 'Bas(se)',
        },
        {
          value: 0,
          name: 'VL',
          label: 'Trés bas(se)',
        },
        {
          value: -1,
          name: 'NOT_EVALUATED',
          label: 'Non évalué',
          hideInScale: true,
        },
      ],
    },
    products:{
      header_title: 'Entraînement de la santé mentale',
      recommended: {
        title: 'Recommandé',
      },
      modules: {
        title: 'Modules',
        sessions: 'Séances',
        button_explore: 'Explorez',
        button_start_session: 'Démarrer la séance',
      },
      first_checkup: {
        text: 'Effectuez un <strong>bilan de santé</strong> pour générer votre recommandation.',
        button: 'Faites un bilan',
      },
      empty: {
        title: '',
        subtitle: '',
      },
      element: {
        popup: {
          tell_more_button: 'En savoir plus',
          download_button: 'Télécharger le PDF',
        },
        workbook: {
          responseHelperText: '',
        },
        goal: {
          title: 'Objectif fixé',
          subtitle: 'Bravo pour avoir créé votre objectif! Travaillons les prochains jours pour le mener à bien. <br><br> Voici votre carte d\'objectifs. Vous pouvez la trouver dans l\'historique de vos objectifs.',
        },
        mood: {
          title: 'Humeur suivie',
          subtitle: 'Voici votre carte des humeurs! Vous pouvez la trouver dans votre historique des humeurs.',
        },
        thought: {
          title: 'Pensée équilibrée',
          subtitle: 'Bravo pour avoir équilibré votre pensée. Penser de façon différente n\'est pas toujours facile.<br><br>Voici votre carte des pensées! Vous pouvez la trouver dans votre historique équilibreur des pensées.',
        },
      },
      comments: {
        buttons: {
          post: 'Publier',
        },
        empty: {
          title: 'Il n\'y a pas encore de commentaire. Partagez vos pensées et écrivez un premier commentaire.',
        },
        author: '{name} (moi)',
        reply: { label: 'Répondre à ce commentaire' },
        comment: { label: 'Envoyer un commentaire avec la communauté' },
        comment_count: '{count} commentaire | {count} commentaires',
        comment_card: {
          actions: {
            delete: {
              label: 'Supprimer',
              icon: 'delete',
            },
            edit: {
              label: 'Modifier',
              icon: 'edit',
            },
            report: {
              label: 'Signaler',
              icon: 'report',
            },
            reported: {
              label: 'Signalé',
              icon: 'check_circle',
            },
          },
          from: 'De',
          preview: 'prévisualiser cet écran',
          translated: 'Ce commentaire a été traduit automatiquement.',
          translated_cancel: 'Voir le commentaire original.',
          reply: 'répondre',
          replies: 'réponses',
          helpfuls: 'J\'aime',
          helpful: 'J\'aime',
          report: {
            title: 'Signaler un commentaire',
            subtitle: 'Merci de signaler ce commentaire. Veuillez s\'il vous plait nous indiquer la raison de ce signalement.',
            reasons: [
              'Contient un langage offensant, agressant ou abusif',
              'C\'est du spam ou hors sujet',
              'Montre un risque élevé de pensées autodestructrices ou suicidaires',
            ],
          },
        },
        sorts: [ 'Trier par plus récent', 'Trier par plus ancien', 'Trier par J\'aime' ],
        notifications: {
          reported: 'Commentaire signalé',
          updated: 'Commentaire mis à jour',
          deleted: 'Commentaire supprimé',
          helpful_marked: '"J\'aime" ajouté au commentaire',
          helpful_unmarked: '"J\'aime" retiré du commentaire',
          replied: 'Réponse ajoutée',
          commented: 'Commentaire ajouté',
        },
      },
      element_types: {
        video: {
          title: 'Vidéo',
          icon: 'mdi-play-box-outline',
          color: '#5CCEFF',
        },
        workbook: {
          title: 'Cahier de travail',
          icon: 'mdi-book-open-page-variant',
          responseLabel: 'Votre réponse',
          responseHelperText: '',
          color: '#C288CB',
        },
        poll: {
          title: 'Sondage',
          icon: 'mdi-poll-box-outline',
          color: '#75CB99',
        },
        question: {
          title: 'Question',
          icon: 'mdi-account-question',
          color: '#FFD176',
        },
        decision: {
          title: 'Décision',
          icon: 'mdi-arrow-decision',
          color: '#FFA4A9',
          subtitle: 'Choisissez ce que vous voulez faire ensuite',
        },
        submenu: {
          title: 'Sous-menu',
          icon: 'mdi-menu-open',
          color: '#0098E1',
          subtitle: 'Choisissez ce que vous voulez faire ensuite',
        },
        tool: {
          title: 'Outil',
          icon: 'mdi-tools',
          color: '#9099AD',
        },
        mood: {
          title: 'Outil de suivi de l\'humeur',
          icon: 'mdi-emoticon-confused',
          color: '#FFB92E',
        },
        html: {
          title: 'Remarque',
          icon: 'mdi-note',
          color: '#6A89FF',
        },
        goal: {
          title: 'Outil d\'établissement d\'objectifs',
          icon: 'mdi-mountain',
          color: '#6CC5B9',
        },
        assessment: {
          title: 'Évaluation',
          icon: 'mdi-head-cog',
          color: '#FF8884',
        },
        thoughts: {
          title: 'Équilibreur de pensée',
          icon: 'mdi-weather-lightning-rainy',
          color: '#E1CCF1',
        },
        mcq: {
          title: 'MCQ',
          icon: 'mdi-format-list-bulleted-square',
          color: '#E1CCF1',
        },
        slider: {
          title: 'Échelle',
          icon: 'mdi-gauge',
          color: '#ff9800',
        },
        composition: {
          title: 'Composition',
          icon: 'mdi-animation-outline',
          color: '#7E8DC1',
        },
        next_step: {
          title: 'Prochaine Étape',
          icon: 'mdi-page-next',
          color: '#736010',
        },
        popup: {
          title: 'Boîte de Dialogue',
          icon: 'mdi-launch',
          color: '#CABE70',
        },
      },
      assessment_history_chart: {
        title: 'Historique de l\'évaluation',
        chart: {
          label: {
            xAxis: 'Dates',
            xAxisVersion: 'final',
            yAxis: 'Pointage',
          },
          score: {
            label: {
              severe: 'Grave',
              moderate: 'Modérée',
              mild: 'Léger',
              border_line: 'Frontière',
              healthy_low: 'En santé : Moyenne faible',
              healthy_average: 'En santé : Moyenne',
              helthy_high: 'En santé : Moyenne élevée',
            },
          },
          assessment: {
            label: {
              gad7: 'ANXIÉTÉ',
              phq9: 'DÉPRESSION',
              stress: 'STRESS',
              energy: 'ÉNERGIE',
              'cd-risc2': 'RÉSILIENCE',
            },
          },
        },
      },
      parts: {
        guide: {
          read_more: 'Lire la suite',
          read_less: 'Lire moins',
        },
      },
    }
  }
};
